import { render, staticRenderFns } from "./ConfigBtn.vue?vue&type=template&id=14c58d3d&scoped=true"
import script from "./ConfigBtn.vue?vue&type=script&lang=js"
export * from "./ConfigBtn.vue?vue&type=script&lang=js"
import style0 from "./ConfigBtn.vue?vue&type=style&index=0&id=14c58d3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c58d3d",
  null
  
)

export default component.exports